/**
 * Spring Data Page response wrapper.
 * All paginated endpoints now return this structure.
 */
export interface PageResponse<T> {
    content: T[];
    pageable: {
        pageNumber: number;
        pageSize: number;
        offset: number;
        sort: {
            sorted: boolean;
            unsorted: boolean;
            empty: boolean;
        };
        paged: boolean;
        unpaged: boolean;
    };
    totalPages: number;
    totalElements: number;
    last: boolean;
    first: boolean;
    size: number;
    number: number;
    numberOfElements: number;
    empty: boolean;
}

/**
 * Pagination query parameters for API requests.
 */
export interface PaginationParams {
    page?: number;      // Default: 0
    size?: number;      // Default: 25, Max: 200
    sort?: string[];    // Format: ["field,direction"] e.g., ["firstName,asc"]
}

/**
 * Helper to build pagination query string.
 */
export function buildPaginationQuery(params: PaginationParams): string {
    const searchParams = new URLSearchParams();

    if (params.page !== undefined) {
        searchParams.append('page', params.page.toString());
    }

    if (params.size !== undefined) {
        searchParams.append('size', params.size.toString());
    }

    if (params.sort) {
        params.sort.forEach(sortStr => {
            searchParams.append('sort', sortStr);
        });
    }

    return searchParams.toString();
}

